import React from "react";

import { Space, Button, Row, Checkbox, Popover } from "antd";
import { SettingOutlined } from "@ant-design/icons";

const SelectColumns = (props) => (
    <>
        <Space direction="vertical">
            {(props.cols || []).map((item, index) => {
                if (item.allowHide) {
                    return (
                        <Checkbox key={index} checked={item.visible} onChange={() => props.onChange(item.key, index)}>
                            {item.title}
                        </Checkbox>
                    );
                }

                return null;
            })}
        </Space>
    </>
);

const Template = (props) => {
    const { cols, onToggleVisible } = props;

    return (
        <Row justify="end">
            <Popover
                placement="bottomRight"
                content={<SelectColumns cols={cols} onChange={onToggleVisible} />}
                title="Columns"
                trigger="click"
            >
                <Button icon={<SettingOutlined />} />
            </Popover>
        </Row>
    );
};

export default Template;
